export default __webpack_public_path__ + "static/media/flag.7fbff879.svg";